<div class="container" *transloco="let t">
  <div class="title box">
    <div class="title">
      <span>{{ t('COMMON.LABEL.COMMENT') }}</span>
    </div>
    <div>
      <app-svg-icon class="white" [path]="'/assets/closebutton.svg'" (click)="closeEvent.emit(true)"></app-svg-icon>
    </div>
  </div>
  <div class="comment">
    <p>{{data}}</p>
  </div>
</div>
